import {
  createFilterOptions,
  createTheme,
  FilterOptionsState,
} from "@mui/material";

const baseFilterOptions = createFilterOptions<string>({
  matchFrom: "any",
  limit: 200,
  stringify: (option: string) => option.toLowerCase(),
});

export const filterOptions = (
  options: string[],
  state: FilterOptionsState<string>
): string[] => {
  const hasSelectAll = options.includes("Select All");
  const optionsWithoutSelectAll = options.filter((opt) => opt !== "Select All");
  const filtered = baseFilterOptions(optionsWithoutSelectAll, state);

  const shouldShowSelectAll =
    hasSelectAll && optionsWithoutSelectAll.length > 2 && filtered.length > 0;

  return shouldShowSelectAll ? ["Select All", ...filtered] : filtered;
};

export const theme = createTheme({
  palette: {
    background: { paper: "#272727" },
    text: { primary: "#ffff" },
  },
});
